export default "__VITE_ASSET__CYjuJ2$8__"